import config from "../../helper/config";
import APIHandler from "../../handlers/APIHandler";

export const passageTypeService = {
    getAll,
    getAllPassageTypes,
    addPassageType,
    updatePassageType,
    deletePassageType,
};

async function getAll(limit, offset, search_term, sort_column, sort_direction) {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    
    const response = await fetch(
        `${config.oat_api_url}/question/passage/types/getAllPassageTypes/?limit=${limit}&offset=${offset}&search_term=${search_term}&sort_column=${sort_column}&sort_direction=${sort_direction}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAllPassageTypes() {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/question/passage/types/getAll/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function addPassageType(newPassageType) {
    const configOptions = {
        method: "POST",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(newPassageType),
    };

    const response = await fetch(
        `${config.oat_api_url}/question/passage/types/add/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function updatePassageType(passageTypeItem, passageTypeId) {
    const configOptions = {
        method: "PUT",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(passageTypeItem),
    };

    const response = await fetch(
        `${config.oat_api_url}/question/passage/types/update/${passageTypeId}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function deletePassageType(id) {
    const configOptions = {
        method: "DELETE",
        headers: {
        ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        "Content-Type": "application/json",
        },
    };

    const response = await fetch(
        `${config.oat_api_url}/question/passage/types/delete/${id}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}
